import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const NUOVO_VUOTO = {
  email: '', password: '', nome: '', cognome: '',
  ruolo: 'dealer', commissione_pct: 0,
  sesso: '',  // 'M' | 'F' | 'altro' | '' (non specificato)
}

export default function AdminUtenti() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState({})

  const [showNuovo, setShowNuovo] = useState(false)
  const [nuovo, setNuovo] = useState(NUOVO_VUOTO)
  const [creando, setCreando] = useState(false)
  const [feedback, setFeedback] = useState(null) // { type: 'success'|'error', text: string }

  useEffect(() => { fetchUsers() }, [])

  async function fetchUsers() {
    setLoading(true)
    const { data } = await supabase.from('profiles').select('*').order('created_at', { ascending: false })
    setUsers(data || [])
    setLoading(false)
  }

  async function save(id) {
    const patch = editing[id]
    if (!patch) return
    await supabase.from('profiles').update(patch).eq('id', id)
    setEditing(e => { const x = { ...e }; delete x[id]; return x })
    fetchUsers()
  }

  async function toggleAttivo(u) {
    await supabase.from('profiles').update({ attivo: !u.attivo }).eq('id', u.id)
    fetchUsers()
  }

  function setField(id, key, val) {
    setEditing(e => ({ ...e, [id]: { ...(e[id] || {}), [key]: val } }))
  }

  function setNuovoField(key, val) {
    setNuovo(n => ({ ...n, [key]: val }))
  }

  function generaPasswordCasuale() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%'
    let p = ''
    for (let i = 0; i < 12; i++) p += chars[Math.floor(Math.random() * chars.length)]
    setNuovoField('password', p)
  }

  async function creaUtente(e) {
    e.preventDefault()
    setFeedback(null)

    if (!nuovo.email || !nuovo.password) {
      setFeedback({ type: 'error', text: 'Email e password obbligatori' })
      return
    }
    if (nuovo.password.length < 8) {
      setFeedback({ type: 'error', text: 'Password minimo 8 caratteri' })
      return
    }

    setCreando(true)
    try {
      // Chiamata alla Supabase Edge Function 'crea-utente' (sostituisce
      // /api/crea-utente del legacy Vercel serverless). supabase.functions.invoke
      // gestisce automaticamente URL della function e header Authorization Bearer.
      const { data, error: invokeErr } = await supabase.functions.invoke('crea-utente', {
        body: nuovo,
      })

      if (invokeErr) {
        // Il messaggio dettagliato sta dentro la response della function
        let msg = invokeErr.message || 'Errore generico'
        try {
          const errBody = await invokeErr.context?.json?.()
          if (errBody?.error) msg = errBody.error
        } catch (_e) { /* ignore */ }
        setFeedback({ type: 'error', text: msg })
      } else if (data?.error) {
        setFeedback({ type: 'error', text: data.error })
      } else {
        setFeedback({ type: 'success', text: `Utente ${nuovo.email} creato con successo. Comunica la password al nuovo utente: ${nuovo.password}` })
        setNuovo(NUOVO_VUOTO)
        setShowNuovo(false)
        fetchUsers()
      }
    } catch (err) {
      setFeedback({ type: 'error', text: 'Errore di rete: ' + err.message })
    }
    setCreando(false)
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Utenti</h1>
          <p>Gestisci dealer, subagenti e amministratori. La creazione utente avviene da qui.</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setShowNuovo(s => !s); setFeedback(null) }}>
          {showNuovo ? 'Annulla' : '+ Crea utente'}
        </button>
      </div>

      {feedback && (
        <div className={`info-box ${feedback.type === 'error' ? 'info-error' : 'info-success'}`} style={{ marginBottom: '1rem' }}>
          {feedback.text}
        </div>
      )}

      {showNuovo && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 className="card-title">Nuovo utente</h2>
          <form onSubmit={creaUtente}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label>Email *</label>
                <input type="email" required value={nuovo.email}
                       onChange={e => setNuovoField('email', e.target.value)} />
              </div>
              <div>
                <label>Password * (minimo 8 caratteri)</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input type="text" required minLength={8} value={nuovo.password}
                         onChange={e => setNuovoField('password', e.target.value)}
                         style={{ flex: 1 }} />
                  <button type="button" className="btn btn-sm" onClick={generaPasswordCasuale}>
                    Genera
                  </button>
                </div>
              </div>
              <div>
                <label>Nome</label>
                <input value={nuovo.nome} onChange={e => setNuovoField('nome', e.target.value)} />
              </div>
              <div>
                <label>Cognome</label>
                <input value={nuovo.cognome} onChange={e => setNuovoField('cognome', e.target.value)} />
              </div>
              <div>
                <label>Sesso</label>
                <select value={nuovo.sesso} onChange={e => setNuovoField('sesso', e.target.value)}>
                  <option value="">Non specificato</option>
                  <option value="M">Maschile</option>
                  <option value="F">Femminile</option>
                  <option value="altro">Altro</option>
                </select>
                <div className="text-small text-muted" style={{ marginTop: 4 }}>
                  Usato per personalizzare i messaggi (Bentornato / Bentornata).
                </div>
              </div>
              <div>
                <label>Ruolo *</label>
                <select value={nuovo.ruolo} onChange={e => setNuovoField('ruolo', e.target.value)}>
                  <option value="dealer">Dealer</option>
                  <option value="subagente">Subagente</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              {nuovo.ruolo !== 'admin' && (
                <div>
                  <label>Competenza fissa % (0-50)</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <input type="range" min="0" max="50" step="0.5"
                           value={nuovo.commissione_pct}
                           onChange={e => setNuovoField('commissione_pct', parseFloat(e.target.value))}
                           style={{ flex: 1 }} />
                    <input type="number" min="0" max="50" step="0.5"
                           value={nuovo.commissione_pct}
                           onChange={e => setNuovoField('commissione_pct', Math.min(50, Math.max(0, parseFloat(e.target.value) || 0)))}
                           style={{ width: 70 }} />
                    <span className="text-small text-muted">%</span>
                  </div>
                </div>
              )}
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', gap: 8 }}>
              <button type="submit" className="btn btn-primary" disabled={creando}>
                {creando ? 'Creazione...' : 'Crea utente'}
              </button>
              <button type="button" className="btn" onClick={() => { setShowNuovo(false); setNuovo(NUOVO_VUOTO) }}>
                Annulla
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Email</th><th>Nome</th><th>Cognome</th><th>Sesso</th><th>Ruolo</th>
                <th>Competenza fissa %</th><th>Attivo</th><th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => {
                const e = editing[u.id] || {}
                const v = (k) => e[k] !== undefined ? e[k] : u[k]
                const dirty = Object.keys(e).length > 0
                return (
                  <tr key={u.id}>
                    <td className="text-small">{u.email}</td>
                    <td><input value={v('nome') || ''} onChange={x => setField(u.id, 'nome', x.target.value)} /></td>
                    <td><input value={v('cognome') || ''} onChange={x => setField(u.id, 'cognome', x.target.value)} /></td>
                    <td>
                      <select value={v('sesso') || ''} onChange={x => setField(u.id, 'sesso', x.target.value || null)}>
                        <option value="">—</option>
                        <option value="M">M</option>
                        <option value="F">F</option>
                        <option value="altro">Altro</option>
                      </select>
                    </td>
                    <td>
                      <select value={v('ruolo')} onChange={x => setField(u.id, 'ruolo', x.target.value)}>
                        <option value="dealer">Dealer</option>
                        <option value="subagente">Subagente</option>
                        <option value="admin">Admin</option>
                      </select>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input type="range" min="0" max="50" step="0.5"
                               value={v('commissione_pct') || 0}
                               onChange={x => setField(u.id, 'commissione_pct', parseFloat(x.target.value))}
                               style={{ width: 100 }} />
                        <input type="number" min="0" max="50" step="0.5"
                               value={v('commissione_pct') || 0}
                               onChange={x => setField(u.id, 'commissione_pct', Math.min(50, Math.max(0, parseFloat(x.target.value) || 0)))}
                               style={{ width: 60 }} />
                        <span className="text-small text-muted">%</span>
                      </div>
                    </td>
                    <td><button className="btn btn-sm" onClick={() => toggleAttivo(u)}>{u.attivo ? '✓ attivo' : '✗ disabilitato'}</button></td>
                    <td>{dirty && <button className="btn btn-sm btn-primary" onClick={() => save(u.id)}>Salva</button>}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
